import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate"
import { TITULO_TURNO_LIST } from "../../../utils/constantes"

export const TurnoPage = () => {
  return <ContenedorPageTemplate titulo={TITULO_TURNO_LIST}>Horariospage</ContenedorPageTemplate>
}